const isObject = item => (item && typeof item === 'object' && !Array.isArray(item));

export const deep = (target, ...sources) => {
  if (!sources.length) {
    return target;
  }

  const source = sources.shift();

  if (isObject(target) && isObject(source)) {
    Object.keys(source).forEach((key) => {
      if (!isObject(source[key])) {
        return Object.assign(target, { [key]: source[key] });
      }

      if (!target[key]) {
        Object.assign(target, { [key]: {} });
      }

      return deep(target[key], source[key]);
    });
  }

  return deep(target, ...sources);
};



/** WEBPACK FOOTER **
 ** ./src/helpers/object/merge.js
 **/